import { render, staticRenderFns } from "./AdvanceSettings.vue?vue&type=template&id=690d3bff&scoped=true"
import script from "./AdvanceSettings.vue?vue&type=script&lang=ts"
export * from "./AdvanceSettings.vue?vue&type=script&lang=ts"
import style0 from "./AdvanceSettings.vue?vue&type=style&index=0&id=690d3bff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690d3bff",
  null
  
)

export default component.exports